export const ACTION_BAR_CROSS_SELL_ANALYTICS_CATEGORY = 'ActionBarCrossSell';

export const ACTION_BAR_CROSS_SELL_ECOM_SOURCE = 'actionBarCrossSell';

export const ACTION_BAR_CROSS_SELL_ITEM_LIST_ID = 'action_bar_cross_sell';
export const ACTION_BAR_CROSS_SELL_ITEM_LIST_NAME = 'Action Bar Cross-Sell';

export type ActionBarMainProductType = 'camera' | 'light';

export type ActionBarCrossSellHiddenReason =
  | 'all_categories_in_cart'
  | 'no_delivery_time_match'
  | 'no_recommendations_for_product';

export interface ActionBarCrossSellCardTrackingPayload {
  category: string;
  product_sku: string;
  selected_length_sku: string | null;
  position: number;
  row: 1 | 2;
  browsed_not_selected: boolean;
}

export interface ActionBarCrossSellAttribution {
  ab_session_id: string;
  ab_category: string;
  ab_result_position: number;
  ab_main_product_sku: string;
  item_list_id: typeof ACTION_BAR_CROSS_SELL_ITEM_LIST_ID;
  item_list_name: typeof ACTION_BAR_CROSS_SELL_ITEM_LIST_NAME;
  selected_via_action_bar: true;
}

export interface ActionBarCrossSellAttributionOptions {
  ab_session_id: string;
  ab_category: string;
  ab_result_position: number;
  ab_main_product_sku: string;
}
